/*
 * sk-variant-stabilizer.js  —  single-selection guard for Variant Swatch King.
 *
 * StarApps shipped an app update that fixed the "fabric 1 shows fabric 2 sizes"
 * desync, so the corrective-toggle logic has been REMOVED to avoid duplicate code.
 *
 * This keeps only a lightweight guard that enforces exactly ONE selected size,
 * synced to the native <select>. It is kept because we render the dual BGN price
 * inside the swatch radios, and injecting price markup into those radios is what
 * originally caused the "double selection" (per StarApps support) — this guard is
 * cheap insurance against that ever recurring. Scoped to <variant-selects> only.
 * Gated by the "Swatch King Variant Fix" theme setting.
 */
(function () {
  'use strict';
  var busy = false, timer = null, observer = null;
  function norm(s) { return (s == null ? '' : String(s)).trim(); }
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }
  function nativeSelect(name) { return document.querySelector('variant-selects select[name="options[' + cssEsc(name) + ']"]'); }
  function inner(li) { return li.querySelector('.swatch-button, .swatch-custom-image'); }
  function itemValue(li) { var b = inner(li); return norm(li.getAttribute('orig-value') || li.getAttribute('aria-label') || (b && b.getAttribute('data-value')) || li.textContent); }
  function unavail(li) { var b = inner(li); var c = (li.className || '') + ' ' + (b ? b.className : ''); return /sold-?out|unavailable|not-?available|disabled/i.test(c) || li.getAttribute('aria-disabled') === 'true'; }
  function isChecked(li) { var b = inner(li); return li.getAttribute('aria-checked') === 'true' || (b && /swatch-selected/.test(b.className)); }
  function setChecked(li, on) { var b = inner(li); li.setAttribute('aria-checked', on ? 'true' : 'false'); if (b) b.classList.toggle('swatch-selected', on); }
  function groupName(ul) { var id = ul.getAttribute('aria-labelledby'); var el = id && document.getElementById(id); return el ? norm(el.textContent) : null; }

  function enforce(ul) {
    var items = [].slice.call(ul.querySelectorAll('li.swatch-view-item'));
    if (!items.length) items = [].slice.call(ul.querySelectorAll('[role="radio"]'));
    if (!items.length) return;
    var name = groupName(ul);
    var sel = name ? nativeSelect(name) : null;
    var nv = sel ? norm(sel.value) : null;
    var match = items.filter(function (li) { return itemValue(li) === nv; })[0];
    var target = match || items.filter(function (li) { return !unavail(li); })[0] || items[0];
    var checked = items.filter(isChecked);
    if (checked.length === 1 && checked[0] === target) return;
    items.forEach(function (li) { setChecked(li, li === target); });
    if (nv !== itemValue(target)) { busy = true; (inner(target) || target).click(); setTimeout(function () { busy = false; }, 300); }
  }
  function run() {
    var gs = document.querySelectorAll('variant-selects [role="radiogroup"], .swatch-single [role="radiogroup"]');
    if (!gs.length) return;
    if (observer) observer.disconnect();
    [].forEach.call(gs, enforce);
    connect();
  }
  function schedule() { if (busy) return; clearTimeout(timer); timer = setTimeout(run, 120); }
  function connect() {
    var root = document.querySelector('variant-selects') || document.querySelector('.swatches');
    if (!root) return;
    if (!observer) observer = new MutationObserver(schedule);
    observer.observe(root.parentNode || root, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-checked', 'class'] });
  }
  function init() {
    var root = document.querySelector('variant-selects') || document.querySelector('.swatches');
    if (!root) { return setTimeout(init, 400); }
    connect();
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.swatch-view-item, .swatch-button, .swatch-single')) schedule(); }, true);
    setTimeout(run, 700);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
